import { render, staticRenderFns } from "./rearrange-toons-page.vue?vue&type=template&id=0c74d6da&scoped=true&lang=pug&"
import script from "./rearrange-toons-page.vue?vue&type=script&lang=js&"
export * from "./rearrange-toons-page.vue?vue&type=script&lang=js&"
import style0 from "./rearrange-toons-page.vue?vue&type=style&index=0&id=0c74d6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74d6da",
  null
  
)

export default component.exports